<div
  class="input-wrapper"
  [formGroup]="formGroup"
  [class.disabled]="disabled"
  [class.input-error]="
    (f[controlName].invalid && f[controlName].touched) || f[controlName]?.hasError('apiError')
  "
  [class.arebic-content-none]="textDirection === 'rtl'"
>
  <!-- <span class="p-float-label p-input-icon-right"> -->
  <!-- -->
  <label class="w-100" [htmlFor]="id" translate>{{ label }}</label>
  <div class="p-inputgroup" dir="ltr">
    <span class="p-inputgroup-addon">
      <ng-content select="[addonContent]"></ng-content>
    </span>
    <input
      class="taly-input"
      [formControlName]="controlName"
      pInputText
      talyAppNumericOnly
      [attr.inputmode]="inputmodeType"
      [id]="id"
      [placeholder]="placeholderText"
      type="text"
      [value]="value"
      #inputField
      [disabled]="disabled"
      [maxlength]="max"
      [minlength]="min"
      pAutoFocus
    />
    @if (!disabled) {
      @if (inputField.value) {
        <span class="close-icon">
          <i
            class="pi pi-times"
            role="button"
            tabindex="0"
            (click)="onReset()"
            (keyup.enter)="onReset()"
          ></i>
        </span>
      }
    }
  </div>
</div>
@if ((f[controlName].invalid && f[controlName].touched) || f[controlName]?.hasError('apiError')) {
  <div class="alert">
    @if (f[controlName].hasError('required')) {
      <span class="alert-danger">
        <img src="assets/images/error-icon.svg" alt="error-icon" class="error-icon" />
        {{ label | translate }} <span class="alert-danger" translate>COMMON.REQUIRED</span>
      </span>
    }

    @if (!f[controlName].hasError('required') && f[controlName]?.hasError('minlength')) {
      <span class="alert-danger">
        <img src="assets/images/error-icon.svg" alt="error-icon" class="error-icon" />
        <span class="alert-danger" translate [translateParams]="{ min: min }"
          >COMMON.MIN_LENGTH</span
        >
        {{ label | translate }}
      </span>
    }

    @if (
      !f[controlName].hasError('required') &&
      !f[controlName]?.hasError('minlength') &&
      f[controlName]?.hasError('maxlength')
    ) {
      <span class="alert-danger">
        <img src="assets/images/error-icon.svg" alt="error-icon" class="error-icon" />
        <span class="alert-danger" translate [translateParams]="{ max: max }"
          >COMMON.MAX_LENGTH</span
        >
        {{ label | translate }}
      </span>
    }

    @if (
      !f[controlName].hasError('required') &&
      !f[controlName]?.hasError('minlength') &&
      !f[controlName]?.hasError('maxlength') &&
      f[controlName]?.hasError('email')
    ) {
      <img src="assets/images/error-icon.svg" alt="error-icon" class="error-icon" />
      <span class="alert-danger" translate> COMMON.INVALID_EMAIL </span>
    }

    @if (
      !f[controlName].hasError('required') &&
      !f[controlName]?.hasError('minlength') &&
      !f[controlName]?.hasError('maxlength') &&
      !f[controlName]?.hasError('email') &&
      f[controlName]?.hasError('pattern')
    ) {
      <span class="alert-danger">
        <img src="assets/images/error-icon.svg" alt="error-icon" class="error-icon" />
        <span class="alert-danger" translate>COMMON.VALID_ENTER</span> {{ label | translate }}
      </span>
    }

    @if (f[controlName]?.hasError('apiError')) {
      <span class="alert-danger">
        <img src="assets/images/error-icon.svg" alt="error-icon" class="error-icon" />
        <span translate>{{ f[controlName]?.getError('apiError')?.apiError }}</span>
      </span>
    }
  </div>
}
